import { MenuItemsType, DropdownMenuItemType } from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'

export type ConfigMenuItemsType = MenuItemsType & { hideSubNav?: boolean }

const config: (t: ContextApi['t']) => ConfigMenuItemsType[] = (t) => [
  {
    label: t('Trade'),
    icon: 'Swap',
    href: '/swap',
    showItemsOnMobile: false,
    items: [
      {
        label: t('Exchange'),
        href: '/swap',
      },
      {
        label: t('Liquidity'),
        href: '/liquidity',
      },
    ],
  },
  {
    label: t('Earn'),
    icon: 'Earn',
    href: '/farms',
    items: [
      {
        label: t('Farms'),
        href: '/farms',
      },
      {
        label: t('Pools'),
        href: '/pools',
      },
      {
        label: t('Farm Auction'),
        href: '/farm-auction',
      },
    ],
  },
  {
    label: t('Lottery'),
    icon: 'Ticket',
    showItemsOnMobile: false,
    href: '/lottery',
    
    items: [
      {
        label: t('Lottery'),
        href: '/lottery',
      },
    ]
  },
  {
    label: t('Predictions'),
    icon: 'Predictions',
    href: '/predictions',
    items: [
      {
        label: t('Predictions'),
        href: '/predictions',
      },
    ] 
  },
  {
    label: t('Info'),
    icon: 'Info',
    href: '/info',
    showItemsOnMobile: false,
    items: [], // Must explicitly be an array
  },
  {
    label: '',
    icon: 'More',
    href: '#',
    hideSubNav: true,
    items: [
      {
        label: t('Website'),
        href: 'https://bescfinancial.com',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
      {
        label: t('Explorer'),
        href: 'https://explorer.vscblockchain.org/',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
    ],
  },
]

export default config
